<template>
    <section class="page13">
        <div class="top-image index-0">
            <img src="~@/assets/img/section-top.png" alt="" />
        </div>
        <div class="conteudo text-left index-2">
            <div class="col1">
                <div class="flex-row" data-aos="fade-right">
                    <div class="yellow text-big text-white">
                        <i>
                            “Vários são os estágios necessários para o
                            compliance com a LGPD e, deste modo, as empresas já
                            devem ter iniciado as suas etapas de implementação,
                            não podendo aguardar, ‘passivamente’, a entrada em
                            vigor da norma. Não deixe para amanhã.”</i
                        >
                    </div>
                    <div class="complete-right">
                        <img src="~@/assets/img/complete-right.png" alt="" />
                    </div>
                </div>
                <div>
                    <p class="subtitle" data-aos="fade" data-aos-delay="1000">
                        Rosana Muknicka, Presidente da Comissão de Proteção de
                        Dados e Direito Digital da OAB-SP, reforça essa urgência
                        de ação pois, dependendo do tamanho da empresa e do
                        número dos empregados, o processo de adequação pode ser
                        longo.
                    </p>
                </div>
            </div>
            <div class="col2">
                <img
                    class="img-shadow"
                    src="~@/assets/img/page12-img.png"
                    alt=""
                    data-aos="fade-up"
                />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page13 {
    position: relative;
    background-image: url("~@/assets/img/page12-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 50px;
    padding-bottom: 50px;
    .complete-right {
        img {
            height: 100%;
        }
    }
    .subtitle {
        padding: 40px 0 0 40px;
    }
    .yellow {
        background-color: $color-yellow;
        padding: 40px;

        line-height: 50px;
    }
    .conteudo {
        // width: 1920px;
        align-items: flex-start;
        padding-top: 20px;
        position: relative;
        z-index: 4;
    }
    .col1 {
        max-width: 617px;
        padding-top: 20px;
        padding-right: 15px;
    }

    @media (max-width: 1250px) {
        padding-left: 20px;
        padding-right: 20px;
        .conteudo {
            .col2 {
                img {
                    max-width: 100%;
                }
            }
        }
    }
    @media (max-width: 1100px) {
        padding-left: 20px;
        padding-right: 20px;
        .conteudo {
            max-width: 100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .complete-right {
                display: none;
            }
            .col1 {
                max-width: 100%;
                width: 100%;
                padding-right: 0;
            }
            .col2 {
                padding-top: 30px;
            }
        }
        .subtitle {
            padding: 20px 0;
        }
    }
}
</style> 